enum UserRoleTypeEnum {
  ADMIN = "admin",
  USER = "user",
  ANONYMOUS = "anonymous",
}

export default UserRoleTypeEnum;
